/**
 * Fallback pageKey resolution when stored notification data lacks pageKey
 * (legacy payloads or resources with dynamic routing).
 */

/** @type {Record<string, string>} */
export const NOTIFICATION_I18N_PREFIX_TO_PAGE_KEY = {
    riskTreatment: 'riskOperationsTreatment',
    riskRegister: 'riskOperationsRiskRegister',
    riskMitigationDefinition: 'riskOperationsTreatment',
    serviceCatalogItem: 'itsmServiceCatalog',
    problem: 'itsmProblem',
    problemCandidate: 'itsmProblem',
    changeRequest: 'itsmChangeRequest',
    document: 'reportDocument',
    interestedParty: 'contextManagementInterestedParties',
    scopeDocument: 'contextManagementScopeDocument',
    exercise: 'bcmExercises',
    crisisEvent: 'bcmCrisisEvent',
    recoveryResources: 'bcmCrisisEvent',
    RecoveryResources: 'bcmCrisisEvent',
    bcp: 'bcmBcp',
    teamAssignment: 'definitionsGeneralSystemTeam',
    teamDutyProfile: 'definitionsGeneralSystemTeam',
    dutyDefinition: 'definitionsGeneralSystemDutyDefinition',
    bcpLocation: 'bcmBcp',
    bcmInitialResponseLibrary: 'bcmBcp',
    bia: 'bcmBia',
    action: 'incidentActions',
    correctiveAction: 'auditComplianceCapa',
    explicitConsent: 'gdprObtainingExplicitConsent',
    assetCategory: 'assetInventoryAssetCategory',
    assetGroup: 'assetInventoryAssetGroup',
    control: 'internalControlControl',
    user: 'userOperationsUserManagement',
    workflowTask: 'myWork',
    workflowInformed: 'myWork',
    operationalRun: 'myWork',
    integrationConnection: 'platformThirdPartyApplications',
    process: 'definitionsGeneralSystemProcess',
    assetDisposal: 'assetInventoryDisposalManagement',
    assetLicense: 'assetInventoryLicenseManagement',
    applicationTracking: 'gdprApplicationTracking',
    dataSubjectRequest: 'gdprApplicationTracking',
    gdprDataSubjectRequest: 'gdprApplicationTracking',
    dataBreach: 'gdprDataBreach',
    gdprDataBreach: 'gdprDataBreach',
    gdprCookieInventory: 'gdprCookieInventory',
    cookieInventory: 'gdprCookieInventory',
    incident: 'incidentIncidents',
    dataProcessingAgreement: 'gdprDpa',
    disposalRun: 'gdprDisposal',
    dpiaAssessment: 'gdprDpiaAssessment',
    consentRecord: 'gdprConsentRecord',
    gdprPrivacyNotice: 'gdprPrivacyNotice',
};

/**
 * @param {string | undefined} i18nKey e.g. "riskTreatment.created"
 * @param {string | undefined} category e.g. "riskTreatments"
 * @returns {string | undefined}
 */
export function resolvePageKeyFromNotificationI18n(i18nKey, category) {
    if (!i18nKey) return undefined;
    const prefix = String(i18nKey).split('.')[0];
    if (prefix === 'action' && category === 'riskTreatments') {
        return 'riskOperationsTreatment';
    }
    return NOTIFICATION_I18N_PREFIX_TO_PAGE_KEY[prefix];
}

/**
 * @param {string | undefined} title stored title or i18n key (e.g. notifications.riskTreatment.created.title)
 * @returns {string | undefined}
 */
export function resolvePageKeyFromNotificationTitle(title) {
    const raw = String(title || '');
    const match = raw.match(/^notifications\.([a-zA-Z0-9]+)\./);
    if (!match) return undefined;
    return resolvePageKeyFromNotificationI18n(`${match[1]}.created`, undefined);
}
